<div id="page-title">
  <h2>Dashboard</h2>
</div>
<hr>
<app-profile-dashboard [user]=" account.currentUser">
</app-profile-dashboard>
